import React from 'react';
import OutlookSnippet from './OutlookSnippet';
import TeamsSnippet from './TeamsSnippet';
import OutlookPreview from './OutlookPreview';
import TeamsPreview from './TeamsPreview';
import CalendarSnippet from './CalendarSnippet';
import FilesSnippet from './FilesSnippet';
import FilesPreview from './FilesPreview';
import CalendarPreview from './CalendarPreview';
import ContactsSnippet from './ContactsSnippet';

interface IOfficeMap{
  [key:string]: any
}

const officeSnippets:IOfficeMap = {
  outlook: OutlookSnippet,
  teams: TeamsSnippet,
  calendar: CalendarSnippet,
  contacts: ContactsSnippet,
  files: FilesSnippet,
}

const officePreviews:IOfficeMap = {
  outlook: OutlookPreview,
  teams: TeamsPreview,
  calendar: CalendarPreview,
  files: FilesPreview,
}

const Office = ({ item, isPreview }: any) => {
  const Snippet = officeSnippets[item['o365-platform']];
  const Preview = officePreviews[item['o365-platform']];
  if (isPreview && Preview) {
    return <Preview item={item} />;
  }

  if(!Snippet) {
    return null;
  }

  return (
    <Snippet item={item} />
  );
}

export default Office;